import { useEffect, useState } from 'react';
import { Modal, Stack, Text, RingProgress, Center, Group } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';

interface MeetingEndingModalProps {
  countdown: number | null;  // null means modal is closed
  onClose?: () => void;
}

export const MeetingEndingModal = ({ countdown, onClose }: MeetingEndingModalProps) => {
  const [currentCount, setCurrentCount] = useState(countdown || 0);

  // Reset counter when countdown prop changes
  useEffect(() => {
    if (countdown !== null) {
      setCurrentCount(countdown);
    }
  }, [countdown]);

  // Countdown timer
  useEffect(() => {
    if (countdown === null || currentCount <= 0) return;

    const timer = setInterval(() => {
      setCurrentCount((prev) => Math.max(0, prev - 1));
    }, 1000);

    return () => clearInterval(timer);
  }, [countdown, currentCount]);

  const isOpen = countdown !== null && currentCount >= 0;
  const progress = countdown ? ((countdown - currentCount) / countdown) * 100 : 0;

  return (
    <Modal
      opened={isOpen}
      onClose={onClose || (() => {})}
      title={
        <Group gap="xs">
          <IconAlertTriangle size={24} color="var(--mantine-color-orange-6)" />
          <Text fw={600} size="lg">Reunião sendo encerrada</Text>
        </Group>
      }
      centered
      size="sm"
      closeOnClickOutside={false}
      closeOnEscape={false}
      withCloseButton={false}
    >
      <Stack align="center" gap="lg" py="md">
        <Text ta="center" size="md" c="dimmed">
          O analista está encerrando a reunião.
        </Text>

        <RingProgress
          size={120}
          thickness={8}
          roundCaps
          sections={[{ value: 100 - progress, color: 'blue' }]}
          label={
            <Center>
              <Text size="xl" fw={700} c="blue">
                {currentCount}
              </Text>
            </Center>
          }
        />

        <Text ta="center" size="sm" c="dimmed">
          Você será desconectado em {currentCount} {currentCount === 1 ? 'segundo' : 'segundos'}...
        </Text>
      </Stack>
    </Modal>
  );
};
